<template>
  <div
    v-infinite-scroll="getComment"
    class="live-index-mobile"
    :class="typeCurrent===1 ? `nofixed` : ``"
  >
    <div class="live-top">
      <div class="tabs">
        <search-btn-bai-mobile v-if="typeCurrent===0 && false" />
        <search-btn-mobile v-if="false" />
        <div class="tabs-list">
          <template v-for="(res, index) in typeList">
            <live-btn-big-mobile
              :key="index"
              height="56px"
              :label="$t(res)"
              :on="index === typeCurrent"
              @click="changeTypeCurrent(index)"
            />
          </template>
        </div>
        <lang-btn-bai-mobile v-if="typeCurrent===0 && false" />
        <lang-btn-mobile v-if="false" />
      </div>
      <div v-if="typeCurrent === 1">
        <div
          class="tabs2"
          v-if="options.childType.length > 1"
        >
          <div class="container">
            <live-tabs-mobille
                :change-type-id="changeTypeId"
                class="live-tabs"
                :list="options.childType"
                :live_comment_stae="options.live_comment_stae"
                :childTypeId="options.childTypeId"
                :liverichang="options.liverichang"
            />
          </div>
        </div>
      </div>
      <div
        v-if="typeCurrent === 1"
        class="live-info"
      >
        <div class="pic">
          <pic-mobile
            v-if="options.info.livesurl === ''"
            :src="options.info.pic"
          />
          <iframe
            v-else
            allowfullscreen="true"
            frameborder="0"
            height="100%"
            mozallowfullscreen="true"
            msallowfullscreen="true"
            oallowfullscreen="true"
            :src="options.info.livesurl"
            webkitallowfullscreen="true"
            width="100%"
          ></iframe>
        </div>
      </div>
      <div
        v-if="typeCurrent === 1"
        class="tab-line"
      >
        <div class="tab-menu">
          <template v-for="(res, index) in (options.liverichang ? tabMenu2: tabMenu)">
            <div
              :key="index"
              class="menu-item"
              :class="(current === res.value) ? `on` : ``"
              @click="setTabCurrent(res.value)"
            >
              {{ $t(res.title) }}
            </div>
          </template>
        </div>
        <div class="btns">
          <icon-text-column-mobile
            class="item"
            color="#c2c2c2"
            font-size="20px"
            icon="views_hei.png"
            :text="options.info.click"
            width="32px"
          />
          <icon-text-zan-mobile
            :id="options.info.id"
            class="item"
            color="#c2c2c2"
            font-size="20px"
            :label="options.info.zan ? options.info.zan.toString() : '0'"
            :set-zan="setZan2"
            :touming="true"
            :type="2"
            width="32px"
            :zan="parseInt(options.info.is_zan) === 1"
          />
          <icon-text-column-mobile
            class="item"
            color="#c2c2c2"
            font-size="20px"
            icon="share_hei.png"
            :text="$t('50016')"
            type="share"
            width="32px"
          />
        </div>
      </div>
    </div>
    <div
      v-if="typeCurrent === 1"
      class="comment-div"
    >
      <div
        v-if="options.liverichang && parseInt(options.info.live_comment_stae) === 1"
        class="comment-form-mobile"
      >
        <input
          v-model="comment"
          :placeholder="$t('21106')"
          type="text"
        />
        <div
          class="submit-btn"
          @click="sendCommentAction"
        >
          {{ $t('21107') }}
        </div>
      </div>
      <div
        class="tab-content container"
        :style="{height: (options.liverichang && parseInt(options.info.live_comment_stae) === 1) ? `calc(100vh - 679px - 260px)` : `calc(100vh - 679px - 150px)`}"
      >
        <live-history-list-mobile
          v-if="options.liverichang && current === `history`"
          :change-live-id="changeLiveIdHistory"
          :options="options"
        />
        <live-comment-list-mobile
          v-if="options.liverichang && current === `comment`"
          :options="options"
        />
        <div
          v-if="current === 'content'"
          class="content-item"
        >
          <text-content-mobile
            :content="$t2(lang, options.info.content, options.info.content_en)"
            title=""
          />
        </div>
        <div
          v-if="current === 'richeng'"
          class="richeng content-item"
        >
          <div class="richeng-view">
            <div class="left">
            </div>
            <div class="right">
              <live-richeng-list-mobile
                :date="options.date"
                :list="options.info.livesList"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="typeCurrent === 0">
      <div
        v-if="loaded"
        class="douyin"
      >
        <div class="progress">
          <mt-range
            v-model="rangeValue"
            :bar-height="5"
            :max="100"
            :min="0"
            :step="1"
            @change="rangeEnd"
          />
        </div>
        <div
          v-if="videoLists.length > 0"
          class="video-info"
        >
          <div class="title">
            {{
              videoLists[videoCurrent]['videoname'] ? $t2(lang, videoLists[videoCurrent]['videoname'], videoLists[videoCurrent]['videoname_en']) : $t(videoLists[videoCurrent].companyname)
            }}
          </div>
          <div class="other">
            <icon-text-location-mobile
              v-if="videoLists[videoCurrent].boothno"
              class="item"
              color="rgba(255,255,255,.8)"
              :label="videoLists[videoCurrent].boothno"
              text-shadow="0 1px 2px #303133"
            />
            <icon-text-line-mobile
              v-if="$t2(lang, videoLists[videoCurrent].projectteamname, videoLists[videoCurrent].projectteamname_en)"
              class="item"
              color="rgba(255,255,255,.8)"
              icon="tag.png"
              :text="$t2(lang, videoLists[videoCurrent].projectteamname, videoLists[videoCurrent].projectteamname_en) "
              text-shadow="0 2px 2px #303133"
              width="20px"
            />
          </div>
        </div>
        <div
          v-if="videoLists.length > 0"
          class="user-info"
        >
          <a
            v-if="videoLists[videoCurrent].linkurl"
            class="pic"
            :href="videoLists[videoCurrent].linkurl"
            target="_blank"
          >
            <pic-mobile :src="videoLists[videoCurrent].logoimageurl" />
            <div class="add-icon"></div>
          </a>
          <div
            v-else
            class="pic"
            @click="navigateTo('/exhibition/info?id='+videoLists[videoCurrent].id)"
          >
            <pic-mobile :src="videoLists[videoCurrent].logoimageurl" />
            <div class="add-icon"></div>
          </div>
          <div class="btns">
            <icon-text-collect-mobile
              :id="videoLists[videoCurrent].id"
              class="item"
              color="#fff"
              :dark="true"
              font-size="20px"
              :label="videoLists[videoCurrent].cang ? videoLists[videoCurrent].cang.toString() : '0'"
              :set-collect="setCollect"
              :shoucang="parseInt(videoLists[videoCurrent].iscang) === 1"
              :type="3"
              width="64px"
            />
            <icon-text-zan-mobile
              :id="videoLists[videoCurrent].id"
              class="item"
              color="#fff"
              :dark="true"
              font-size="20px"
              :label="videoLists[videoCurrent].zan ? videoLists[videoCurrent].zan.toString() : '0'"
              :set-zan="setZan"
              text-shadow="0 1px 2px #303133"
              :type="3"
              width="64px"
              :zan="parseInt(videoLists[videoCurrent].iszan) === 1"
            />
            <icon-text-column-mobile
              class="item"
              color="#fff"
              font-size="20px"
              icon="live_share.png"
              :text="$t('50016')"
              type="share"
              width="64px"
            />
          </div>
        </div>
        <swiper
          ref="mySwiper"
          :options="swiperOptionsTop"
        >
          <template
            v-for="(res, index) in videoLists"
          >
            <swiper-slide
              v-if="(index >= 0 && index <= videoCurrent + 2)"
              :key="index"
            >
              <div
                class="video"
              >
                <video
                  v-if="(index >= videoCurrent-1 && index <= videoCurrent + 1)"
                  :ref="'player_'+index"
                  playsinline="true"
                  :poster="res.imageurl"
                  :src="res.videourl"
                  webkit-playsinline="true"
                  x5-playsinline="true"
                  @click="stop"
                ></video>
                <span
                  v-if="!playing && (index >= videoCurrent-1 && index <= videoCurrent + 1)"
                  class="play_btn"
                  @click="play"
                ></span>
              </div>
            </swiper-slide>
          </template>
        </swiper>
      </div>
    </div>
    <template v-if="options.info.state==0">
      <template
        v-if="isWechat && typeCurrent === 1"
      >
        <template v-if="user.mid && openid">
          <subscribe-modal-live :options="options" />
        </template>
        <template v-else>
          <button
            v-if="!user.mid"
            class="yuyue-btn"
            @click="yuyueTip"
          >
          </button>
        </template>
        <button
          v-if="user.mid && !openid"
          class="yuyue-btn"
          @click="openidTip"
        >
        </button>
      </template>
      <button
        v-if="!isWechat"
        class="yuyue-btn"
        @click="qrcodeShow"
      >
      </button>
    </template>
    <div
      v-if="modalShow"
      class="qrcode-modal"
      @click="modalShow=false"
    >
      <div class="qrcode-modal-main-body">
        <div class="qrcode-modal-main-body-title">
          预约提醒
        </div>
        <div class="qrcode-modal-main-body-title-tip">
          微信识别二维码 预约本场直播提醒
        </div>
        <div class="qrcode-modal-main-body-info">
          <div class="qrcode">
            <div
              ref="qrCodeUrl"
              style="width: 264px; height: 264px;"
            >
              <div class="icon-logo">
                <div
                  class="img"
                  :style="{background:'url('+(require('../../../assets/images/logo_ico.png'))+')', backgroundSize: '100% 100%'}"
                ></div>
              </div>
            </div>
          </div>
          <div class="qrcode-tip">
            <img
              class="text-icon"
              src="../../../assets/images/login-qrcode-icon.png"
            />
            微信扫码
          </div>
        </div>
        <div class="qrcode-modal-main-body-logo">
          <img src="../../../assets/images/mobile/logo_bai.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from "vuex";
import {Range} from 'mint-ui';
import LiveTabsMobille from "../../../components/Mobile/Live/LiveTabs";
import PicMobile from "../../../components/Mobile/common/Pic";
import IconTextColumnMobile from "../../../components/Mobile/common/IconTextColumn";
import TextContentMobile from "../../../components/Mobile/common/TextContent";
import LiveRichengListMobile from "../../../components/Mobile/Live/LiveRichengList";
import LiveBtnBigMobile from "../../../components/Mobile/Live/LiveBtnBig";

import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
// import swiper module styles
import '@/assets/swiper.css'
import IconTextLocationMobile from "../../../components/Mobile/common/IconText/location";
import IconTextLineMobile from "../../../components/Mobile/common/IconTextLine";
import IconTextCollectMobile from "../../../components/Mobile/common/IconText/collect";
import IconTextZanMobile from "../../../components/Mobile/common/IconText/zan";
import LangBtnMobile from "../../../components/Mobile/common/LangBtn";
import SearchBtnMobile from "../../../components/Mobile/common/SearchBtn";
import LangBtnBaiMobile from "../../../components/Mobile/common/LangBtnBai";
import SearchBtnBaiMobile from "../../../components/Mobile/common/SearchBaiBtn";
import LiveHistoryListMobile from "../../../components/Mobile/Live/LiveHistoryList";
import LiveCommentListMobile from "../../../components/Mobile/Live/LiveCommentList";
import $ from 'jquery'
import moment from "moment";
import QRCode from "qrcodejs2";
import Setting from "@/config/setting.config";
import SubscribeModalLive from "@/components/Mobile/common/SubscribeLive/index.vue";

export default {
  name: 'LiveIndexMobile',
  components: {
    SubscribeModalLive,
    LiveCommentListMobile,
    LiveHistoryListMobile,
    mtRange: Range,
    SearchBtnBaiMobile,
    LangBtnBaiMobile,
    SearchBtnMobile,
    LangBtnMobile,
    IconTextZanMobile,
    IconTextCollectMobile,
    IconTextLineMobile,
    IconTextLocationMobile,
    LiveBtnBigMobile,
    LiveRichengListMobile,
    TextContentMobile, IconTextColumnMobile, PicMobile, LiveTabsMobille,
    Swiper, SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    options: {
      type: Object,
      default: () => {
      }
    },
    changeTypeId: {
      type: Function,
      default: () => () => {}
    },
    liverichang: {
      type: Boolean,
      default: () => false
    },
    changeLiveId: {
      type: Function,
      default: () => () => {
      }
    },
    getComment: {
      type: Function,
      default: () => () => {
      }
    },
    changeLiveIdHistory: {
      type: Function,
      default: () => () => {
      }
    },
    sendComment: {
      type: Function,
      default: () => () => {
      }
    },
    changeLiveIdMobile: {
      type: Function,
      default: () => () => {
      }
    }
  },
  data() {
    return {
      comment: '',
      videoPlayer: null,
      rangeValue: 0,
      loaded: false,
      playing: false,
      swiperOptionsTop: {},
      typeCurrent: 0,
      current: 'history',
      isWechat: false,
      subscribeNode: '',
      typeList: [
        '50005', //推荐
        '10004'
      ],
      tabMenu: [
        {
          title: '22003',
          value: 'content'
        },
        {
          title: '50023',
          value: 'richeng'
        }
      ],
      tabMenu2: [
        {
          title: '21104',
          value: 'comment'
        },
        {
          title: '22003',
          value: 'content'
        },
        {
          title: '21105',
          value: 'history'
        }
      ],
      videoList: [],
      videoCurrent: 0,
      currentTime: 0,
      duration: 0,
      modalShow: false,
      btn: false,
      btnobj: null,
      openid: localStorage.getItem('openid')
    }
  },
  computed: {
    ...mapState(['browser', 'lang', 'windowHeight', 'user']),
    videoLists() {
      return this.videoList
      // return this.videoList.sort(function () {
      //   return Math.random() - 0.5;
      // })
    },
    swiper() {
      return this.$refs.mySwiper ? this.$refs.mySwiper.$swiper : null
    }
  },
  // watch: {
  //   options: {
  //     deep: true,
  //     handler(newVal, oldVal) {
  //       if(newVal.info.livesurl !== ''){
  //         if (this.videoPlayer !== null) {
  //           this.videoPlayer.destroy()
  //           this.videoPlayer = null
  //         }
  //         this.$nextTick(() => {
  //           setTimeout(() => {
  //             this.videoPlayer = new HlsPlayer({
  //               id: 'welcomeVideo',
  //               url: newVal.info.livesurl,
  //               poster: newVal.info.pic,
  //               playsinline: true,
  //               fluid: true
  //             });
  //           }, 500)
  //         })
  //       }
  //     }
  //   }
  // },
  activated() {
    this.url = window.location.href + (window.location.href.indexOf('?') > -1 ? '&' : '?') + 'share=1';
  },
  mounted() {
    this.url = window.location.href + (window.location.href.indexOf('?') > -1 ? '&' : '?') + 'share=1';
    if (this.$route.query.typeCurrent) {
      this.typeCurrent = parseInt(this.$route.query.typeCurrent)
    }
    if (this.typeCurrent === 1) {
      // this.changeLiveIdMobile(parseInt(this.$route.query.liveid))
    }
    if (navigator.userAgent.indexOf('MicroMessenger') > -1 || navigator.userAgent.indexOf('WeChat') > -1 || navigator.userAgent.indexOf('Weixin') > -1 || navigator.userAgent.indexOf('weixin') > -1) {
      this.isWechat = true;
    } else {
      this.isWechat = false;
    }
    this.init();
    const _t = this;
    this.$nextTick(() => {
      this.loaded = true
      this.swiperOptionsTop = {
        direction: 'vertical',
        height: this.windowHeight - 100,
        width: this.windowWidth,
        autoplay: false,
      }
      this.getWxConfig(this.options.data.title, moment.unix(this.options.data.live_start_time).format('YYYY/MM/DD HH:mm') + ' ~ ' + moment.unix(this.options.data.live_end_time).format('HH:mm'), this.options.data.pic)

    })
  },
  beforeDestroy() {
    if (this.videoPlayer !== null) {
      this.videoPlayer.destroy()
      this.videoPlayer = null
    }
    this.btn.addEventListener('success', null)
    this.btn.addEventListener('error', null)
  },
  methods: {
    qrcodeShow() {
      this.modalShow = true;
      this.$nextTick(() => {
        this.creatQrCode()
      })
    },
    creatQrCode() {
      $('.qrcode').find('img').remove();
      $('.qrcode').find('canvas').remove();
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.purl || this.url, // 需要转换为二维码的内容
        width: 264,
        height: 264,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    rangeEnd(r) {
      if (this.duration) {
        this.$refs['player_' + this.videoCurrent][0].currentTime = this.duration * (r / 100)
      }
    },
    init() {
      const _t = this;
      this.$u.api.lives.getVideoLists().then(res => {
        if (res.status === 1) {
          this.videoList = res.data
          this.$nextTick(() => {
            this.swiper.on('slideChangeTransitionEnd', function () {
              console.log('videoCurrent', _t.videoCurrent)
              _t.stop()
              _t.videoCurrent = this.realIndex
              _t.currentTime = 0;
              _t.rangeValue = 0;
              _t.duration = 0;
              _t.play()
            })
          })
          this.$nextTick(() => {
            this.play()
          })
        }
      })
    },
    yuyueTip(){
      this.$confirm('您还没有登录，登录后可以订阅，是否立即登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'mobile-message'
      }).then(() => {
        localStorage.setItem('backUrl', this.$router.currentRoute.path)
        localStorage.setItem('backQuery', JSON.stringify(this.$router.currentRoute.query))
        this.navigateTo('/user/login')
      })
    },
    openidTip(){
      this.$confirm('您还没有绑定微信，授权绑定后可以订阅，是否立即使用微信授权登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'mobile-message'
      }).then(() => {
        window.location = Setting.appDomain.api + "/api.php/wechat/wechatLogin?url=" + encodeURI(window.location.href)
      })
    },
    stop() {
      this.playing = false;
      this.$refs['player_' + this.videoCurrent][0].pause()
    },
    play() {
      const _this = this;
      this.duration = this.$refs['player_' + this.videoCurrent][0].duration
      this.$refs['player_' + this.videoCurrent][0].play()
      this.$refs['player_' + this.videoCurrent][0].onended = () => {
        this.swiper.slideTo(this.videoCurrent + 1, 1000)
      };
      this.$refs['player_' + this.videoCurrent][0].ontimeupdate = () => {
        _this.currentTime = _this.$refs['player_' + _this.videoCurrent][0].currentTime
        _this.rangeValue = (_this.currentTime * 100 / _this.duration)
      };
      // console.log('aa', this.videoList[this.videoCurrent]);
      // this.$u.api.ajaxs.actLive({t: 1, is_value: this.videoList[this.videoCurrent].id});
      // this.$refs['player_'+this.videoCurrent][0].
      this.playing = true;
      if(this.videoList[this.videoCurrent].typeid){
        this.$u.api.ajaxs.actLive({t: 4, is_value: this.videoList[this.videoCurrent].id});
      }else if(this.videoList[this.videoCurrent].companyname){
        this.$u.api.ajaxs.actLive({t: 1, is_value: this.videoList[this.videoCurrent].id});
      }
    },
    setCollect(v) {
      this.videoLists[this.videoCurrent].iscang = v
      if (v === 0) {
        this.videoLists[this.videoCurrent].cang--
      } else {
        this.videoLists[this.videoCurrent].cang++
      }
      this.$forceUpdate()
    },
    setZan(v) {
      this.videoLists[this.videoCurrent].iszan = v
      if (v === 0) {
        this.videoLists[this.videoCurrent].zan--
      } else {
        this.videoLists[this.videoCurrent].zan++
      }
      this.$forceUpdate()
    },
    setZan2(v) {
      this.options.info.is_zan = v;
      if (v === 0) {
        this.options.info.zan--
      } else {
        this.options.info.zan++
      }
      this.$forceUpdate()
    },
    sendCommentAction() {
      this.sendComment(this.comment)
      this.comment = ''
    },
    setCurrent(current) {
      this.current = current
    },
    changeTypeCurrent(index) {
      if (this.isIOS) {
        window.location.href = '/Live?typeCurrent=' + index
      } else {
        this.$router.replace({
          path: '/Live',
          query: {typeCurrent: index}
        })
        if (index === 0) {
          this.getWxConfig(this.$t('10004'), this.$t('10004'))
        } else {
          this.getWxConfig(this.options.info.title, moment.unix(this.options.info.live_start_time).format('YYYY/MM/DD HH:mm') + ' ~ ' + moment.unix(this.options.info.live_end_time).format('HH:mm'), this.options.info.pic)
        }
        this.typeCurrent = index
      }
    },
    setTabCurrent(index) {
      this.current = index
      index === 'history' && this.setHistoryView();
    },
    setHistoryView() {
      this.$nextTick(() => {
        let father = $('.tab-content');
        let scrollTo = $('.live-history-item-mobile.on');
        father.animate({
          scrollTop: scrollTo.offset().top - father.offset().top + father.scrollTop() - 20
        }, 1000);
      })
    }
  }
}
</script>

<style
    lang="scss"
    scoped
>
.live-index-mobile {
  position: fixed;
  top: 20px;
  width: 100%;
  z-index: 2;

  &.nofixed {
    padding-bottom: 100px;

    .live-top {
      width: 100%;
      position: fixed;
      top: 0;
      padding-top: 20px;
      left: 0;
      z-index: 2;
    }

    .tab-content {
      height: calc(100vh - 679px - 260px);
      top: 650px;
      position: relative;
      overflow-y: auto;
    }
  }

  .douyin {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 150px;
    right: 0;
    height: calc(100vh - 166px);
    background: #000;
    background-size: 100% 100%;

    .progress {
      position: fixed;
      bottom: 153px;
      left: 0;
      width: 100%;
      z-index: 11;
    }

    .user-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .pic {
        width: 86px;
        height: 86px;
        border-radius: 86px;
        box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
        position: relative;
        overflow: visible;

        & > div {
          border-radius: 86px;
          overflow: hidden;
        }

        .add-icon {
          position: absolute;
          bottom: -10px;
          left: 50%;
          margin-left: -21px;
          width: 42px;
          height: 28px;
          background: url("../../../assets/images/mobile/live_video_add.png");
          background-size: 100% 100%;
        }
      }

      .btns {
        width: 64px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .item {
          margin-top: 30px;
        }
      }

      right: 20px;
      position: fixed;
      bottom: 280px;
      z-index: 10;
    }

    .video-info {
      position: absolute;
      left: 30px;
      bottom: 50px;
      z-index: 20;

      .title {
        font-size: 30px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
        text-shadow: 0 2px 4px #303133;
      }

      .other {
        .item {
          margin-top: 5px;
        }
      }
    }

    .video {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      video {
        width: auto;
        max-width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .play_btn {
        width: 94px;
        height: 94px;
        background: url("../../../assets/images/play_big.png");
        background-size: 100% 100%;
        background-position: center;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -47px;
        margin-top: -47px;
        cursor: pointer;
      }
    }
  }

  .tabs {
    text-align: center;
    position: relative;
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 36px;

    .tabs-list {
    }
  }

  .live-tabs {
    margin-top: 22px;
    overflow-x: auto;
    white-space: nowrap;
  }

  .live-info {
    .pic {
      margin-top: 20px;
      width: 100%;
      height: 422px;
    }
  }

  .tab-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    padding: 12px 36px;

    .tab-menu {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .menu-item {
        margin-right: 36px;
        color: rgba(255, 255, 255, 0.5);
        font-weight: 600;

        &.on {
          font-weight: 600;
          color: #fff;
          position: relative;

          &:after {
            display: block;
            content: ' ';
            width: 32px;
            height: 8px;
            background: linear-gradient(223deg, #FF4E1A 0%, #FF9B61 100%);
            border-radius: 4px;
            position: absolute;
            bottom: -32px;
            left: 50%;
            margin-left: -16px;
          }
        }
      }
    }

    .btns {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item {
        margin-left: 45px;
      }
    }
  }

  .richeng-view {
    position: relative;

    .left {
      background: linear-gradient(223deg, #FF1A2C 0%, #FF9B61 100%);
      width: 2px;
      height: 100%;
      opacity: 0.2;
      position: absolute;
      left: 20px;
      top: 0;
    }

    .right {
      margin-left: 56px;
    }
  }

  .comment-form-mobile {
    width: 100%;
    height: 90px;
    display: inline-block;
    background: #020E1B;
    vertical-align: top;
    padding: 10px 36px;
    position: fixed;
    left: 0;
    bottom: 150px;

    input {
      color: #6d737a;
      display: inline-block;
      border: 0;
      width: 558px;
      padding: 5px 10px;
      height: 69px;
      line-height: 69px;
      background: rgba(245, 245, 245, 0.15);
      border-radius: 8px 0 0 8px;
    }

    .submit-btn {
      position: absolute;
      right: 36px;
      top: 10px;
      display: inline-block;
      width: 120px;
      line-height: 69px;
      text-align: center;
      color: #fff;
      height: 69px;
      background: #FF511A;
      font-size: 24px;
      font-weight: 500;
      border-radius: 0 8px 8px 0;
    }
  }

  .yuyue-btn {
    position: fixed;
    right: 20px;
    bottom: 260px;
    width: 92px;
    height: 92px;
    background: url('data:image/png;base64,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');
    box-shadow: 0 18px 36px 0 rgba(51, 12, 0, 0.4);
    z-index: 99999;
    border-radius: 46px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 0;

    &-icon {
      width: 36px;
      height: 36px;
      background: url("../../../assets/images/mobile/yuyue-mobile.png");
      background-size: 100% 100%;
    }

    color: #fff;
    font-size: 20px;
  }

  .qrcode-modal {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;

    &-main-body {
      width: 80%;
      background: linear-gradient(#FC501E, #FA8958);
      border-radius: 28px;
      position: relative;
      padding-bottom: 50px;

      &-title {
        width: 100%;
        text-align: center;
        font-size: 36px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #fff;
        line-height: 42px;
        margin-top: 50px;
      }

      &-title-tip {
        width: 100%;
        text-align: center !important;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #fff;
        line-height: 14px;
        margin-top: 30px;
      }

      &-info {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        border-radius: 28px;
        flex-direction: column;
        padding: 40px;
        width: 380px;
        margin: 50px auto 0;

        .qrcode {
          padding: 45px;
          border-radius: 10px;
          margin-bottom: 10px;
        }

        .qrcode-tip {
          text-align: center;

          .text-icon {
            width: 28px;
            height: 28px;
          }

          font-size: 22px;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }

  .qrcode-modal-main-body-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;

    img {
      width: 193px;
      height: 36px;
    }
  }
}
</style>
<style>


.yuyue-btn {
  position: fixed;
  right: 20px;
  bottom: 260px;
  width: 92px;
  height: 92px;
  background: linear-gradient(#FF7F34, #FF511A);
  box-shadow: 0 18px 36px 0 rgba(51, 12, 0, 0.4);
  z-index: 99999;
  border-radius: 46px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 20px;
}

.yuyue-btn-icon {
  width: 36px;
  height: 36px;
  background: url('data:image/png;base64,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');
  background-size: 100% 100%;
}
</style>
